/**
 * @file コンポーネント：フル動画ページフル動画プレイヤー字幕 ロジック管理
 */

// ライブラリ読み込み
import React, { useEffect, useRef, useState } from "react";

// Presenter読み込み
import { Presenter } from "./presenter";

// コンポーネントを返す
export const FullvideoPlayerSubtitle = (props) => {
    /**
     * 字幕表示
     */
    const [arrayFnDeleteSubtitle, setArrayFnDeleteSubtitle] = useState([]); // 字幕消去処理を格納
    const [subtitle, setSubtitle] = useState(null); // 字幕データ
    const refText = useRef(null); // 字幕テキスト要素
    useEffect(() => {
        const tempSubtitlelist = props.subtitlelist;
        if (subtitle === null && tempSubtitlelist.length > 0) {
            // 字幕を表示
            setSubtitle(tempSubtitlelist[0]);
            // 字幕消去処理を5秒後にセット
            const fnDeleteSubtitle = setTimeout(() => {
                tempSubtitlelist.shift();
                props.setSubtitlelist(tempSubtitlelist);
                setSubtitle(null);
            }, 5000);
            const tempArrayFnDeleteSubtitle = arrayFnDeleteSubtitle;
            tempArrayFnDeleteSubtitle.push(fnDeleteSubtitle);
            setArrayFnDeleteSubtitle(tempArrayFnDeleteSubtitle);
        }
    }, [props.countSubtitlelist, subtitle]);
    // 字幕テキストの折り返しごとにspanタグでラップする処理
    useEffect(() => {
        if (subtitle !== null && subtitle.isWrapped !== true) {
            // 字幕ノード
            const textNode = refText.current.firstChild;
            if (textNode !== null) {
                // 1つ前の文字の座標格納
                let previousRect = null;
                // 折り返し位置格納
                const positionSplit = [];
                for (let i = 0; i < textNode.length; i++) {
                    // 対象文字を取得
                    const range = document.createRange();
                    range.setStart(textNode, i);
                    range.setEnd(textNode, i + 1);
                    // 対象文字の座標を取得
                    const rect = range.getBoundingClientRect();
                    // 前の文字とy座標が異なれば折り返したとみなす
                    if (previousRect && previousRect.y < rect.y) {
                        positionSplit.push(i);
                    }
                    // 1つ前の文字の座標として格納
                    previousRect = rect;
                }
                // 折り返しごとにspanでラップする
                let text = "";
                if (positionSplit.length > 0) {
                    for (let j = 0; j <= positionSplit.length; j++) {
                        // 切り出し開始位置
                        let indexStart = 0;
                        if (0 < j) {
                            indexStart = positionSplit[j - 1];
                        }
                        if (j < positionSplit.length) {
                            // 最後以外は文字列を指定区間で切り出し
                            text +=
                                "<span>" +
                                textNode.textContent.substring(
                                    indexStart,
                                    positionSplit[j]
                                ) +
                                "</span>";
                        } else {
                            // 最後は第2引数省略し、文字列の最後まで切り出し
                            text +=
                                "<span>" +
                                textNode.textContent.substring(indexStart) +
                                "</span>";
                        }
                    }
                } else {
                    text = "<span>" + textNode.textContent + "</span>";
                }
                setSubtitle({ ...subtitle, ...{ isWrapped: true, text } });
            }
        }
    }, [subtitle]);

    /**
     * ローディング開始時に字幕情報をリセット
     */
    useEffect(() => {
        if (props.isLoadingFullvideo) {
            // 字幕を消去
            setSubtitle(null);
            // 待機中の字幕をリセット
            props.setSubtitlelist([]);
            // セット済みの字幕消去処理をキャンセル
            arrayFnDeleteSubtitle.forEach((fn) => {
                clearTimeout(fn);
            });
            // 字幕消去処理をリセット
            setArrayFnDeleteSubtitle([]);
        }
    }, [props.isLoadingFullvideo]);

    // Presenterに渡す
    return <Presenter {...props} refText={refText} subtitle={subtitle} />;
};
